import DashboardLayout from "../layouts/DashboardLayout";

const withDashboardLayout = (WrappedComponent) => {
    const WithDashboardLayout = (props) => (
        <DashboardLayout>
            <WrappedComponent {...props} />
        </DashboardLayout>
    );
    return WithDashboardLayout;
};

export default withDashboardLayout;